import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaBroom} from "react-icons/fa";

function CommercialCleaningServices() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

     const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "We were getting cleanliness complaints almost every week. After Helper Ji’s commercial cleaning team started, the situation improved gradually. Now the office stays clean most of the day.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Helper Ji cleaning staff doesn’t rush the work. Floors, desks, and washrooms are cleaned properly, which we didn’t get from earlier vendors.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "We started with basic cleaning from Helper Ji, and later added more areas because the service quality stayed consistent.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

const services = [
    {
      name: "Commercial Cleaning Services Gurugram",
      link: "/commercial-cleaning-services-gurugram",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Ghaziabad",
      link: "/commercial-cleaning-services-ghaziabad",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Delhi",
      link: "/commercial-cleaning-services-delhi",
      icon: <FaBroom />
    }
  ];

  return (
    <Fragment>
      <Helmet>

        {/* BASIC META */}
    <title>Commercial Cleaning Services in Noida | Best Office Cleaning Company</title>
    <meta
      name="description"
      content="Hire professional commercial cleaning services in Noida offering deep cleaning services, office cleaning & corporate cleaning solutions by best commercial cleaning company."
    />
    <meta
      name="keywords"
      content="Commercial Cleaning Services In Noida, Deep Cleaning Services In Noida, Best Commercial Cleaning Company In Noida, Best Office Cleaning Services In Noida, Commercial Cleaning Services Company In Noida, Professional Commercial Cleaning Services In Noida"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://www.helperji.in/commercial-cleaning-services-noida"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Commercial Cleaning Services in Noida | Best Office Cleaning Company"
    />
    <meta
      property="og:description"
      content="Hire professional commercial cleaning services in Noida offering deep cleaning services, office cleaning & corporate cleaning solutions by best commercial cleaning company."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta
      property="og:url"
      content="https://www.helperji.in/commercial-cleaning-services-noida"
    />
    <meta property="og:type" content="website" />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Commercial Cleaning Services in Noida | Best Office Cleaning Company"
    />
    <meta
      name="twitter:description"
      content="Hire professional commercial cleaning services in Noida offering deep cleaning services, office cleaning & corporate cleaning solutions by best commercial cleaning company."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/commercial-cleaning-services-noida",
        "name": "Commercial Cleaning Services in Noida | Best Office Cleaning Company",
        "description": "Hire professional commercial cleaning services in Noida offering deep cleaning services, office cleaning & corporate cleaning solutions by best commercial cleaning company."
      }
      `}
    </script>

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Commercial Cleaning Services in Noida",
        "image": "https://www.helperji.in/assets/img/officeclean.jpg",
        "description": "Hire professional commercial cleaning services in Noida offering deep cleaning services, office cleaning & corporate cleaning solutions by best commercial cleaning company.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "498"
        }
      }
      `}
    </script>

    {/* BREADCRUMB SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Commercial Cleaning Services",
            "item": "https://www.helperji.in/commercial-cleaning-services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Commercial Cleaning Services in Noida",
            "item": "https://www.helperji.in/commercial-cleaning-services-noida"
          }
        ]
      }
      `}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Why should I hire professional commercial cleaning services in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Hiring commercial office cleaning services helps maintain hygiene, reduce dust, and create a professional workspace. Helper Ji is known as the best commercial cleaning company in Noida for structured and reliable cleaning."
            }
          },
          {
            "@type": "Question",
            "name": "Do you provide office cleaning services for IT parks and co-working spaces in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer complete office cleaning services in Noida for IT parks, shared offices, and corporate buildings with minimal work disruption."
            }
          },
          {
            "@type": "Question",
            "name": "Are your commercial office cleaning prices affordable in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our commercial office cleaning prices are transparent and based on office size and cleaning frequency, making them suitable for small and large businesses."
            }
          },
          {
            "@type": "Question",
            "name": "Is Helper Ji a professional commercial cleaning company?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji operates as a professional commercial cleaning company with trained staff and standard cleaning practices."
            }
          },
          {
            "@type": "Question",
            "name": "Which areas do you cover in Noida?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We provide the best office cleaning services in Noida across all sectors and business locations."
            }
          }
        ]
      }
      `}
    </script>
      <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
        
      </Helmet>
      <Floatingcall />
      <section id="about" class="about">
        <div class="container" data-aos="fade-up">
          <div class="section-header">
            <h2>COMMERCIAL CLEANING SERVICES IN NOIDA</h2>
            <p>
              Are you looking for{" "}
              <b>best Commercial Cleaning service in Noida</b> then contact
              Helper Ji today.{" "}
            </p>
          </div>

          <div class="row gy-4">
            <div class="col-lg-6">
              <img
                src="/assets/img/officeclean.jpg"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>

            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <p className="text-justify">
                  Helper Ji provides structured, reliable, and professional
                  commercial cleaning services in Noida, for businesses that
                  prioritise hygiene and organisation. If you are searching for
                  the best commercial cleaning company in Noida, we deliver
                  dependable solutions that help maintain a clean, safe, and
                  productive office environment.
                </p>
                <p className="text-justify">
                  Our office cleaning services in Noida are suitable for
                  corporate offices, IT parks, co-working spaces, commercial
                  complexes, and business centres. Each service is carefully
                  planned to ensure thorough cleaning without disturbing daily
                  work operations. We focus on cleanliness, safety, and
                  consistency in every visit.
                </p>
                <p className="text-justify">
                  Our commercial office cleaning services are designed to match
                  the specific needs of different office environments. Whether
                  it is regular maintenance or detailed cleaning, our team
                  follows structured processes to ensure hygienic workspaces.
                  This helps reduce dust, maintain cleanliness, and support
                  employee well-being.
                </p>
                <div class="text-left">
                  <Link
                    to="/contact-us"
                    className="booknow"
                    onClick={scrollToTop}
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" class="services sections-bg">
        <div class="container" data-aos="fade-up">
          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <p className="text-justify">
                  Our commercial cleaning services in Noida support offices
                  across multiple industries, including corporate offices,
                  startups, IT companies, and commercial buildings. We ensure
                  dependable cleaning solutions regardless of workspace size.
                </p>
                <p className="text-justify">
                  Maintain a clean and organised workplace with Helper Ji. Book
                  the best office cleaning services in Noida today and
                  experience professional cleaning that supports your business
                  operations..
                </p>

                <h3> Why Choose Helper Ji in Noida</h3>
                <p>
                  As a trusted commercial cleaning company in Noida, Helper Ji
                  offers:
                </p>

                <ul>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Experienced
                    professionals handling commercial office cleaning services.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Trained staff
                    following proper cleaning standards.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Clear and reasonable
                    commercial office cleaning prices.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Use of safe and
                    effective cleaning products.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Reliable schedules
                    with consistent service quality.
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6">
              <img
                src="/assets/img/officecleaning.jpg"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

    <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

      <section id="services" class="services sections-bg">
        <div className="container">
          <h3>
            FAQs – COMMERCIAL CLEANING SERVICES IN NOIDA
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  Why should I hire professional commercial cleaning services in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Hiring commercial office cleaning services helps maintain hygiene, reduce dust, and create a professional workspace. Helper Ji is known as the best commercial cleaning company in Noida for structured and reliable cleaning.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Do you provide office cleaning services for IT parks and co-working spaces in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, we offer complete office cleaning services in Noida for IT parks, shared offices, and corporate buildings with minimal work disruption.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Are your commercial office cleaning prices affordable in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our commercial office cleaning prices are transparent and based on office size and cleaning frequency, making them suitable for small and large businesses.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Is Helper Ji a professional commercial cleaning company?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, Helper Ji operates as a professional commercial cleaning company with trained staff and standard cleaning practices.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Which areas do you cover in Noida?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  We provide the Best office cleaning services in Noida across all sectors and business locations.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    <LandingPageClient />
   
       <section className="py-5 sections-bg">
                  <div className="container">
                    <div className="row mb-4">
                      <div className="col text-center">
                        <h2 className="fw-bold">Other Locations</h2>
                        <p className="text-muted">
                          Explore our other locations of Commercial Cleaning Services
                        </p>
                      </div>
                    </div>
            
                    <div className="row g-4">
                      {services.map((service, index) => (
                        <div className="col-md-4 col-sm-6" key={index}>
                          <Link
                            to={service.link}
                            className="text-decoration-none text-dark"
                          >
                            <div className="card h-100 shadow-sm border-0 service-card">
                              <div className="card-body d-flex align-items-center">
                                <div className="service-icon me-3">
                                  {service.icon}
                                </div>
                                <h6 className="mb-0 fw-semibold">
                                  {service.name}
                                </h6>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                </section>

    </Fragment>
  );
}

export default CommercialCleaningServices;
